import { useState } from 'react';
import { largeBoxes, smallBoxes } from '../articleInfo';
import '../styles/App.css';
import LargeBox from './LargeBox';
import SmallBox from './SmallBox';

function App() {
  const [largeBoxesState, setLargeBoxesState] = useState(largeBoxes);
  const [smallBoxesState, setSmallBoxesState] = useState(smallBoxes);
  return (
    <div id="appContainer">
      <div id="app">
        
        <div id="bannerHolder">
          <img id="banner" src="./assets/EndowmentBanner2.png" />
        </div>

        <div class="mainContainer">
          <LargeBox props={largeBoxesState[0]} />
          <div class="smallBoxHolder">
            <SmallBox props={smallBoxesState[0]} />
            <SmallBox props={smallBoxesState[1]} />
          </div>
        </div>

        <div class="mainContainer">
          <div class="smallBoxHolder">
            <SmallBox props={smallBoxesState[2]} />
            <SmallBox props={smallBoxesState[3]} />
          </div>
          <LargeBox props={largeBoxesState[1]} />
        </div>

        <div class="mainContainer">
          <LargeBox props={largeBoxesState[2]} />
          <div class="smallBoxHolder">
            <SmallBox props={smallBoxesState[4]} />
            <SmallBox props={smallBoxesState[5]} />
          </div>
        </div>

        <div class="mainContainer">
          <div class="smallBoxHolder">
            <SmallBox props={smallBoxesState[6]} />
            <SmallBox props={smallBoxesState[7]} />
          </div>
          <LargeBox props={largeBoxesState[3]} />
        </div>

      </div>
    </div>
  );
}

export default App;
